import { render } from "./DashboardAc1.vue?vue&type=template&id=47342fda&scoped=true"
import script from "./DashboardAc1.vue?vue&type=script&lang=js"
export * from "./DashboardAc1.vue?vue&type=script&lang=js"

import "./DashboardAc1.vue?vue&type=style&index=0&id=47342fda&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47342fda"]])

export default __exports__